/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ColumnMetaNumberType;
(function (ColumnMetaNumberType) {
    ColumnMetaNumberType["INT"] = "int";
    ColumnMetaNumberType["FLOAT"] = "float";
})(ColumnMetaNumberType || (ColumnMetaNumberType = {}));
export function ColumnMetaNumberTypeFromJSON(json) {
    return ColumnMetaNumberTypeFromJSONTyped(json, false);
}
export function ColumnMetaNumberTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ColumnMetaNumberTypeToJSON(value) {
    return value;
}
